<template>
    <div class="free-screen" :class="$i18n.locale === 'dk' ? 'dk' : ''">
        <svg class="ai_arrow" width="67.9079455px" height="94.3093026px" viewBox="0 0 67.9079455 94.3093026" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Illustrations" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Group-5" fill="#FFFFFF" fill-rule="nonzero">
                    <g id="AI">
                        <path d="M7.55199292,10.3039903 L7.0399934,12.2239885 L11.4879892,12.2239885 L11.0079897,10.3039903 C10.7306566,9.25865799 10.4479902,8.14932569 10.1599905,6.97599346 C9.87199075,5.80266123 9.58932434,4.67199562 9.31199127,3.58399664 L9.18399139,3.58399664 C8.92799163,4.69332893 8.66665854,5.82932787 8.39999212,6.99199345 C8.13332571,8.15465902 7.85065931,9.25865799 7.55199292,10.3039903 Z M0,20.8639804 L6.52799388,0 L12.1919886,0 L18.7199824,20.8639804 L13.7279871,20.8639804 L12.4479883,15.9039851 L6.0799943,15.9039851 L4.7999955,20.8639804 L0,20.8639804 Z" id="Shape"></path>
                        <polygon id="Path" points="20.9916894 20.8639804 20.9916894 0 25.695685 0 25.695685 20.8639804"></polygon>
                    </g>
                    <path d="M13.2180799,29.8653067 L13.334083,29.8793572 C13.8778754,29.9758365 14.2404943,30.4948793 14.144015,31.0386717 C7.59120974,67.9726652 21.0947167,85.9495526 54.9391097,85.5701325 L63.0330584,85.0589804 L54.0721766,80.7367163 C53.6102525,80.5139458 53.3972336,79.9826257 53.5612419,79.5095677 L53.605841,79.4016016 C53.8457477,78.9041449 54.4434989,78.6953593 54.9409557,78.9352661 L67.3422921,84.9160148 C68.0446745,85.2547503 68.1063103,86.2313502 67.4520885,86.6557046 L55.901081,94.1481492 C55.4377337,94.4486948 54.818476,94.3167179 54.5179304,93.8533705 C54.2173848,93.3900232 54.3493617,92.7707656 54.8127091,92.47022 L63.1600584,87.0549804 L55.0133467,87.5680836 C19.8039376,87.9642009 5.41230772,68.8049773 12.1747685,30.6892892 C12.2574651,30.2231814 12.6506164,29.8901807 13.1037042,29.8653067 L13.2180799,29.8653067 Z" id="Path-2"></path>
                </g>
            </g>
        </svg>
       <div class="video">
            <Transition name="fade">
                <div v-if="loading" class="video_loader"></div>
            </Transition>
            <Transition name="fade">
                <iframe
                    v-if="videoKey"
                    :key="videoKey"
                    :src="videoUrl"
                    @load="handleLoad"
                    title="Synthesia video player - PrivacyMonitor Dashboard"
                    allowfullscreen
                    allow="encrypted-media; fullscreen;"
                    style="
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        border: none;
                        padding: 0;
                        margin: 0;
                        overflow: hidden;
                    "
                ></iframe>
            </Transition>
        </div>
        <h3 class="video-subtitle">5 min and you are ready... (no credit card required)</h3>
        <h2 class="relv-title">
            {{ $t("free.title") }}
        </h2>
        <p class="relv-subtitle" v-html="$t('free.message')"></p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            videoUrl: 'https://share.synthesia.io/embeds/videos/101ab54c-1bfa-4e58-af18-eada86947974',
            videoKey: null
        }
    },
    methods: {
        fullPricing() {
            this.$emit('fullPricing')
        },
        handleLoad() {
            setTimeout(() => {
                this.loading = false
                this.iframeVisible = true
            }, 600)
        }
    },
    mounted() {
        this.videoKey = Date.now()
    }
}
</script>

<style lang="scss" scoped>
.free-screen {
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    width: 100%;
    background: #0b5f79;
    border-radius: 32px;
    overflow: hidden;

    --card-color: #0b5f79;
    --pillar-size: 36px;
    --big-circle-r: 32px;
    --circle-r: 32px;
    --circle-d: calc(var(--circle-r) * 2);
    --circles-space: calc(var(--big-circle-r) + var(--pillar-size));
    --circle-extend-inset: calc(var(--circle-r) + var(--circles-space));

    &::before {
        content: url(/img/bg_logo.svg);
        position: absolute;
        left: -50%;
    }

    .ai_arrow {
        position: absolute;
        top: 10%;
        left: calc(12% - 32px);
        width: 48px;
    }

    .relv-title {
        font-weight: 600;
        color: rgba(255, 255, 255, 0.8) !important;
        line-height: 40px;
    }
    .relv-subtitle {
        color: rgba(255, 255, 255, 0.64) !important;

        b {
            color: rgba(255, 255, 255, 1) !important;
        }
    }

    .btn-try {
        position: absolute;
        top: 10px;
        right: 12px;

        display: flex;
        align-items: center;
        gap: 16px;
        padding: 12px 16px;
        background-color: color(bg, green);
        font-weight: 600;
        font-size: 18px;
        color: #ffffff;
        line-height: 24px;
        border-radius: 32px;
        transition: all 0.3s ease-in-out;

        .button__icon-wrapper {
            flex-shrink: 0;
            width: 25px;
            height: 25px;
            position: relative;
            color: color(bg, green);
            background-color: #fff;
            border-radius: 50%;
            display: grid;
            place-items: center;
            overflow: hidden;
            transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);

            .button__icon-svg--copy {
                position: absolute;
                transform: translate(-150%, 150%);
            }
        }

        &:hover {
            cursor: pointer;
            background-color: color(typo, dark);
            .button__icon-wrapper {
                color: color(typo, dark);

                .button__icon-svg {
                    &:first-child {
                        transition: transform 0.2s ease-in-out;
                        transform: translate(150%, -150%);
                    }
                }

                .button__icon-svg--copy {
                    transition: transform 0.4s ease-in-out 0.1s;
                    transform: translate(0);

                    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                }
            }
        }
    }
}

.video {
    position: relative;
    overflow: hidden;
    display: flex;
    width: 68%;
    aspect-ratio: 16/9;
    border-radius: $radius;
    background-color: transparent;

    &:has(+ .links) {
        margin-bottom: 0;
    }

    iframe {
        background-color: transparent;
    }

    .video_loader {
        position: absolute;
        z-index: 2;
        background: rgba(0, 0, 0, 0.96);
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        border-radius: $radius;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;

        &::before {
            content: '';
            width: 60px;
            height: 60px;
            border: 4px solid #ffffff;
            border-top-color: color(bg, blue);
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
            to {
                transform: rotate(360deg);
            }
        }
    }
}

.video-subtitle {
    color: rgba(255, 255, 255, 1);
    font-size: 1rem;
    font-weight: 600 !important;
    margin-top: 0.75rem;
    text-align: center;
    opacity: 1;
}
</style>
